import { Navigate, Route, Routes } from "react-router-dom";
import AdminAuth from "./components/auth/AdminAuth";
import RequireAuth from "./components/auth/RequireAuth";
import UserAuth from "./components/auth/UserAuth";
import Layout from "./components/shared/layout/Layout";
import Loading from "./components/shared/loading/Loading";
import useSession from "./hooks/useSession";
import AboutPage from "./page/AboutPage/AboutPage";
import BlogContentPage from "./page/BlogPage/BlogContentPage";
import BlogCreate from "./page/BlogPage/BlogCreate";
import BlogListPage from "./page/BlogPage/BlogListPage";
import BlogUniquePage from "./page/BlogPage/BlogUniquePage";
import ExpectationPage from "./page/ExpectationPage/ExpectationPage";
import FooterPage from "./page/FooterPage/FooterPage";
import GalleryPage from "./page/GalleryPage/GalleryPage";
import HomeClients from "./page/HomeClients/HomeClients";
import HomeBanner from "./page/HomePage/HomeBanner";
import NavBarPage from "./page/NavBarPage/NavBarPage";
import ProjectContentPage from "./page/ProjectPage/ProjectContentPage";
import ProjectCreate from "./page/ProjectPage/ProjectCreate";
import ProjectListPage from "./page/ProjectPage/ProjectListPage";
import ProjectUniquePage from "./page/ProjectPage/ProjectUniquePage";
import ServiceContentPage from "./page/ServicePage/ServiceContentPage";
import ServiceListPage from "./page/ServicePage/ServiceListPage";
import ServicePage from "./page/ServicePage/ServicePage";
import TeamContentPage from "./page/TeamPage/TeamContentPage";
import TeamCreate from "./page/TeamPage/TeamCreate";
import TeamListPage from "./page/TeamPage/TeamListPage";
import TeamUniquePage from "./page/TeamPage/TeamUniquePage";
import Login from "./page/UserPage/Login";
import ManageUser from "./page/UserPage/ManageUser";
import UserCreate from "./page/UserPage/UserCreate";
import UserUpdate from "./page/UserPage/UserUpdate";
import ClientUniqueReview from "./page/HomeClients/ClientUniqueReview";
import ClientListPage from "./page/HomeClients/ClientListPage";
import { RoutePath } from "./utility/Constant";
import ClientsReviewCreate from "./page/HomeClients/ClientsReviewCreate";
import CareerPage from "./page/Career/CareerPage";
import ClientCreate from "./page/HomeClients/ClientCreate";
import ClientUniquePage from "./page/HomeClients/ClientUniquePage";
import CSRFocusPage from "./page/csr/CSRFocusPage";
import CSRFocusUniquePage from "./page/csr/CSRFocusUniquePage";
import CSRFocusAddPage from "./page/csr/CSRFocusAddPage";
import CSRCollabPage from "./page/csr/colab/CSRCollabPage";
import CsrHighlightpage from "./page/csr/CsrHighlightpage";
import CsrHighlightUniquepage from "./page/csr/CsrHighlightUniquepage";
import CsrHighlightAddpage from "./page/csr/CsrHighlightAddpage";
import WorkListPage from "./page/csr/works/WorkListPage";
import WorkUniquepage from "./page/csr/works/WorkUniquepage";
import WorkAddpage from "./page/csr/works/WorkAddpage";
import ContactPage from "./page/contact/ContactPage";
import PackageContentPage from "./page/PackagePage/PackageContentPage";
import PackageListPage from "./page/PackagePage/PackageListPage";
import PackageCreate from "./page/PackagePage/PackageCreate";
import PackageUniquePage from "./page/PackagePage/PackageUniquePage";
import JobsPage from "./page/JobsPage/JobsPage";
import JobsCreate from "./page/JobsPage/JobsCreate";
import EditJobs from "./page/JobsPage/EditJobs";

function App() {
  const [user, loading] = useSession();
  if (loading) {
    return <Loading />;
  }
  const {
    navBar,
    homeBanner,
    about,
    serviceContent,
    serviceList,
    dynamicService,
    projectContent,
    projectList,
    dynamicProject,
    addProject,
    packageContent,
    packageList,
    addPackage,
    dynamicPackage,
    teamContent,
    teamList,
    dynamicTeam,
    addMember,
    expectation,
    clients,
    addClients,
    dynamicClient,
    clientsReview,
    dynamicClientsReview,
    addReview,
    gallery,
    blogsContent,
    blogList,
    dynamicBlog,
    addBlog,
    footer,
    career,
    jobs,
    addJobs,
    editJobs,
    manageUser,
    dynamicUser,
    addUser,
    login,
    csrFocus,
    addCsrFocus,
    dynamicCsrFocus,
    csrCollaboration,
    csrHighlights,
    dynamicCsrHighlights,
    addCsrHighlights,
    csrWorks,
    dynamicCsrWorks,
    addCsrWorks,
    contact,
  } = RoutePath;

  return (
    <div>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route
            index
            element={
              <Navigate to={user?.role === "admin" ? navBar : projectContent} />
            }
          />
          <Route
            path={navBar}
            element={
              <AdminAuth>
                <NavBarPage />
              </AdminAuth>
            }
          />
          <Route
            path={homeBanner}
            element={
              <AdminAuth>
                <HomeBanner />
              </AdminAuth>
            }
          />
          <Route
            path={about}
            element={
              <AdminAuth>
                <AboutPage />
              </AdminAuth>
            }
          />

          {/* -------------- CSR pages -------------- */}
          <Route
            path={csrFocus}
            element={
              <AdminAuth>
                <CSRFocusPage />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicCsrFocus}
            element={
              <AdminAuth>
                <CSRFocusUniquePage />
              </AdminAuth>
            }
          />
          <Route
            path={addCsrFocus}
            element={
              <AdminAuth>
                <CSRFocusAddPage />
              </AdminAuth>
            }
          />
          <Route
            path={csrCollaboration}
            element={
              <AdminAuth>
                <CSRCollabPage />
              </AdminAuth>
            }
          />
          <Route
            path={csrHighlights}
            element={
              <AdminAuth>
                <CsrHighlightpage />
              </AdminAuth>
            }
          />

          <Route
            path={dynamicCsrHighlights}
            element={
              <AdminAuth>
                <CsrHighlightUniquepage />
              </AdminAuth>
            }
          />

          <Route
            path={addCsrHighlights}
            element={
              <AdminAuth>
                <CsrHighlightAddpage />
              </AdminAuth>
            }
          />
          <Route
            path={csrWorks}
            element={
              <AdminAuth>
                <WorkListPage />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicCsrWorks}
            element={
              <AdminAuth>
                <WorkUniquepage />
              </AdminAuth>
            }
          />

          <Route
            path={addCsrWorks}
            element={
              <AdminAuth>
                <WorkAddpage />
              </AdminAuth>
            }
          />

          <Route
            path={serviceContent}
            element={
              <AdminAuth>
                <ServiceContentPage />
              </AdminAuth>
            }
          />
          <Route
            path={serviceList}
            element={
              <AdminAuth>
                <ServiceListPage />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicService}
            element={
              <AdminAuth>
                <ServicePage />
              </AdminAuth>
            }
          />

          {/* wahid  */}
          <Route path={packageContent} element={<PackageContentPage />} />
          <Route path={packageList} element={<PackageListPage />} />
          <Route path={dynamicPackage} element={<PackageUniquePage />} />
          <Route path={addPackage} element={<PackageCreate />} />

          <Route path={projectContent} element={<ProjectContentPage />} />
          <Route path={projectList} element={<ProjectListPage />} />
          <Route path={dynamicProject} element={<ProjectUniquePage />} /> // projectList/:id
          <Route path={addProject} element={<ProjectCreate />} />

          <Route path={teamContent} element={<TeamContentPage />} />
          <Route path={teamList} element={<TeamListPage />} />
          <Route path={dynamicTeam} element={<TeamUniquePage />} />
          <Route path={addMember} element={<TeamCreate />} />

          <Route
            path={expectation}
            element={
              <AdminAuth>
                <ExpectationPage />
              </AdminAuth>
            }
          />
          <Route
            path={clients}
            element={
              <AdminAuth>
                <HomeClients />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicClient}
            element={
              <AdminAuth>
                <ClientUniquePage />
              </AdminAuth>
            }
          />
          <Route
            path={addClients}
            element={
              <AdminAuth>
                <ClientCreate />
              </AdminAuth>
            }
          />
          {/* reviews */}
          <Route
            path={clientsReview}
            element={
              <AdminAuth>
                <ClientListPage />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicClientsReview}
            element={
              <AdminAuth>
                <ClientUniqueReview />
              </AdminAuth>
            }
          />
          <Route
            path={addReview}
            element={
              <AdminAuth>
                <ClientsReviewCreate />
              </AdminAuth>
            }
          />

          <Route path={gallery} element={<GalleryPage />} />

          <Route path={blogsContent} element={<BlogContentPage />} />
          <Route path={blogList} element={<BlogListPage />} />
          <Route path={dynamicBlog} element={<BlogUniquePage />} />
          <Route
            path={addBlog}
            element={
              <AdminAuth>
                <BlogCreate />
              </AdminAuth>
            }
          />
          <Route
            path={career}
            element={
              <AdminAuth>
                <CareerPage />
              </AdminAuth>
            }
          />
          <Route
            path={jobs}
            element={
              <AdminAuth>
                <JobsPage />
              </AdminAuth>
            }
          />
          <Route
            path={addJobs}
            element={
              <AdminAuth>
                <JobsCreate />
              </AdminAuth>
            }
          />
          <Route
            path={editJobs}
            element={
              <AdminAuth>
                <EditJobs />
              </AdminAuth>
            }
          />
          <Route
            path={footer}
            element={
              <AdminAuth>
                <FooterPage />
              </AdminAuth>
            }
          />
          <Route
            path={contact}
            element={
              <AdminAuth>
                <ContactPage />
              </AdminAuth>
            }
          />

          <Route
            path={manageUser}
            element={
              <AdminAuth>
                <ManageUser />
              </AdminAuth>
            }
          />
          <Route
            path={dynamicUser}
            element={
              <AdminAuth>
                <UserUpdate />
              </AdminAuth>
            }
          />
          <Route
            path={addUser}
            element={
              <AdminAuth>
                <UserCreate />
              </AdminAuth>
            }
          />
        </Route>
        <Route
          path={login}
          element={
            <UserAuth>
              <Login />
            </UserAuth>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
